import { render } from "./GetAddress.vue?vue&type=template&id=070957aa"
import script from "./GetAddress.vue?vue&type=script&lang=js"
export * from "./GetAddress.vue?vue&type=script&lang=js"

import "./GetAddress.vue?vue&type=style&index=0&id=070957aa&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__